import image1 from "../Assets/villa.jpg";
import image2 from "../Assets/Apartment.jpg";
// import image3 from "../Assets/hotel-apartment.jpg";
import image4 from "../Assets/alhana_center_2.webp";
import image5 from "../Assets/administrative.jpg";
import image6 from "../Assets/medical.jpg";
import image7 from "../Assets/woman-working-pharmacy-wearing-coat.jpg";
import image8 from "../Assets/new-cairo-city.jpg";

import experienceIcon from "../Assets/experience-iconnn.png";
import trustIcon from "../Assets/trust-icon.png";
import varietyIcon from "../Assets/variety-icon.png";

import phone from "../Assets/phone.png";
import email from "../Assets/email.png";
import location from "../Assets/location-1.png";

import villa1 from "../Assets/Grove_villa_1.webp";
import villa2 from "../Assets/garhoud_villa_main.webp";
import villa3 from "../Assets/rashidiyya_villa.webp";
import villa4 from "../Assets/villa4.jpeg";
import villa5 from "../Assets/villa5.jpg";
import villa6 from "../Assets/jaffiliya_villa_1.webp";

import apartment1 from "../Assets/apartemn1.jpg";
// import apartment2 from "../Assets/apartemn2.jpg";
// import apartment3 from "../Assets/apartemn3.jpg";
// import apartment4 from "../Assets/apartemn4.jpeg";
// import apartment5 from "../Assets/apartemn5.jpg";
// import apartment6 from "../Assets/apartemn6.jpeg";

import hotelApartment1 from "../Assets/tower1.jpeg";
import hotelApartment2 from "../Assets/towe2.jpg";
import hotelApartment3 from "../Assets/towe3.jpg";
import hotelApartment4 from "../Assets/tower4.jpg";
import hotelApartment5 from "../Assets/tower5.jpg";

import commercial1 from "../Assets/alhana_center_2.webp";
import commercial2 from "../Assets/nouf_tower_front.webp";
import commercial3 from "../Assets/Grove_court_2.webp";
// import commercial4 from "../Assets/commercial4.jpg";
// import commercial5 from "../Assets/commercial5.jpg";
// import commercial6 from "../Assets/commercial6.jpeg";

import administrative1 from "../Assets/alhana_center_1.webp";
import administrative2 from "../Assets/nouf_tower_front.webp";
// import administrative3 from "../Assets/administrative3.jpg";
// import administrative4 from "../Assets/administrative4.jpeg";
// import administrative5 from "../Assets/administrative5.jpg";
// import administrative6 from "../Assets/administrative6.jpg";

import AHMMC from "../Assets/Al hana mmc.webp";
import emirates_hospital from "../Assets/emirates_hospital.jpg";
// import medica3 from "../Assets/medical3.png";
// import medica4 from "../Assets/medical4.jpg";
// import medica5 from "../Assets/medical5.jpg";
// import medica6 from "../Assets/medical6.jpg";

import pharmacy1 from "../Assets/logo-AL-HANA-pharmacy.webp";
// import pharmacy2 from "../Assets/pharmacies2.jpg";
// import pharmacy3 from "../Assets/pharmacies3.jpg";
// import pharmacy4 from "../Assets/pharmacies4.jpg";
// import pharmacy5 from "../Assets/pharmacies5.jpg";
// import pharmacy6 from "../Assets/pharmacies6.jpg";

import archvilla from "../Assets/arch.webp";
// import newCairo2 from "../Assets/newCairo2.jpg";
// import newCairo3 from "../Assets/newCairo3.jpg";
// import newCairo4 from "../Assets/newCairo4.jpeg";
// import newCairo5 from "../Assets/newCairo5.jpeg";








import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";

export const projectsData = [
  {
    id: 1,
    title: "Villa",
    description: "Settle In a Modern Villa With Your Family",
    image: image1,
    to: "/projects/villa",
  },
  {
    id: 2,
    title: "Apartment",
    description: "Experience urban living at its finest in our apartments",
    image: image2,
    to: "/projects/apartment",
  },
  // {
  //   id: 3,
  //   title: "Hotel Apartment",
  //   description: "Discover unlimited options and move to the new capital city",
  //   image: image3,
  //   to: "/projects/hotelApartment",
  // },
  {
    id: 4,
    title: "Commercial",
    description: "Open your new store in Heart Of Dubai",
    image: image4,
    to: "/projects/commercial",
  },
  {
    id: 5,
    title: "Administrative",
    description: "Your new office in a modern work environment",
    image: image5,
    to: "/projects/administrative",
  },
  {
    id: 6,
    title: "Medical",
    description: "Medical units available with different facilities",
    image: image6,
    to: "/projects/medical",
  },
  {
    id: 7,
    title: "Pharmacies",
    description:
      "Healthcare made easy with pharmacies units with different facilities",
    image: image7,
    to: "/projects/pharmacies",
  },
  {
    id: 8,
    title: "Up Coming Projects",
    description:
      "Stay tuned for exciting new real estate developments coming soon!",
    image: image8,
    to: "/projects/Upcoming Projects",
  },
];

// export const headerData = [
//   { id: 1, title: "Home", to: "/" },
//   { id: 2, title: "Projects", to: "/projects" },
//   { id: 3, title: "About", to: "/about" },
//   { id: 4, title: "Contact", to: "/contact" },
// ];

export const clientTestimonialsData = [
  {
    id: 1,
    number: "500+",
    title: "Clients",
    description:
      "Proudly serving a huge number of satisfied clients from different nationalities",
  },

  {
    id: 2,
    number: "30+",
    title: "Projects",
    description:
      "Consultancy in many real estate projects of all types all over Dubai",
  },

  {
    id: 3,
    number: "30",
    title: "Years",
    description:
      "Profound knowledge and extensive experience throughout the years in real estate field",
  },
];

export const aboutUsData = [
  {
    id: 1,
    title: "Experience",
    image: experienceIcon,
    description:
      "Based on our extensive experience and resources, we provide sincere consultancy you can depend on to help you with your investment and property buying decisions.",
    bgColor: "#6082B6",
  },
  {
    id: 2,
    title: "Trust",
    image: trustIcon,
    description:
      "We have built a reputation through meaningful communication and honesty with our clients. We are trusted to fulfill promises and take care of our clients’ concerns.",
    bgColor: "#4682B4",
  },

  {
    id: 3,
    title: "Variety",
    image: varietyIcon,
    description:
      "We specialize in various projects that offer all types of units such as apartments, penthouses, villas, commercial, administrative, and medical units.",
    bgColor: "#6082B6",
  },

  
];

// export const footerIcons = [
//   { id: 1, icon: FaFacebookSquare },
//   { id: 2, icon: FaInstagram },
//   { id: 3, icon: FaLinkedin },
//   { id: 4, icon: FaTwitter },
// ];

// export const formData = [
//   {
//     id: 1,
//     name: "firstName",
//     type: "text",
//     placeholder: "First Name",
//   },
//   {
//     id: 2,
//     name: "lastName",
//     type: "text",
//     placeholder: "Last Name",
//   },

//   {
//     id: 3,
//     name: "phone",
//     type: "number",
//     placeholder: "Your Phone",
//   },

//   {
//     id: 4,
//     name: "email",
//     type: "email",
//     placeholder: "Your Email (optional)",
//   },
// ];

// export const contactInfoData = [
//   { id: 1, title: "+20 1151747091", image: phone },
//   { id: 2, title: "mustafakhaledinfo@gmail.com", image: email },
//   { id: 3, title: "Cairo, Egypt", image: location },
// ];

export const villaData = [
  {
    id: 1,
    image: villa1,
    title: "GROVE COURT",
    discount: "",
    Installment: 14,
    price: ""
  },

  {
    id: 2,
    image: villa2,
    title: "GARHOUD VILLAS",
    discount: "",
    Installment: 6,
    price: ""
  },

  {
    id: 3,
    image: villa3,
    title: "RASHIDIYYA VILLAS",
    discount: "",
    Installment: 10,
    price: ""
  },

  // {
  //   id: 4,
  //   image: villa4,
  //   title: "JUMEIRAH VILLAS",
  //   discount: "",
  //   Installment: 6,
  //   price: ""
  // },

  // {
  //   id: 5,
  //   image: villa5,
  //   title: "JUMEIRAH P3",
  //   discount: "",
  //   Installment: 6,
  //   price: ""
  // },

  // {
  //   id: 6,
  //   image: villa5,
  //   title: "VILLA NOVA",
  //   discount: "",
  //   Installment: 1,
  //   price: ""
  // },

  {
    id: 7,
    image: villa6,
    title: "JAFFILIYA VILLAS",
    discount: "",
    Installment: 6,
    price: ""
  },
];

export const apartmentsData = [
  {
    id: 1,
    image: apartment1,
    title: "Al Hudaiba Building ",
    discount: "",
    Installment: 32,
    price:"100000",
    location:"https://www.google.com/search?q=supeco+jafiliya&sca_esv=624b65d66f479d2b&biw=1280&bih=559&tbm=lcl&sxsrf=AHTn8zpSAsVSG5zGdm8zoju-Fz3xDwCYRA%3A1739521268755&ei=9PyuZ9PpLcSOi-gP3fWDMA&ved=0ahUKEwjTs7ba3cKLAxVExwIHHd36AAYQ4dUDCAo&uact=5&oq=supeco+jafiliya&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIg9zdXBlY28gamFmaWxpeWEyBRAhGKABMgUQIRigATIFECEYoAFI_jFQAFieK3AAeACQAQCYAcoCoAHSF6oBCDAuMTIuMi4xuAEDyAEA-AEBmAIPoAL0F8ICBBAjGCfCAgsQABiABBiRAhiKBcICChAAGIAEGEMYigXCAgsQABiABBixAxiDAcICDhAAGIAEGLEDGIMBGIoFwgIQEAAYgAQYsQMYQxiDARiKBcICCBAAGIAEGLEDwgILEAAYgAQYsQMYyQPCAgsQABiABBiSAxiKBcICBRAAGIAEwgINEAAYgAQYsQMYgwEYCsICChAAGIAEGLEDGArCAgcQABiABBgKwgIGEAAYFhgewgIIEAAYCBgNGB7CAgUQABjvBcICCBAAGKIEGIkFwgIHECEYoAEYCpgDAJIHBzAuOS41LjGgB4NI&sclient=gws-wiz-local#rlfi=hd:;si:11750235710844701183,l,Cg9zdXBlY28gamFmaWxpeWFIvL7igvuVgIAIWiEQABABGAAYASIPc3VwZWNvIGphZmlsaXlhKgYIAhAAEAGSAQtzdXBlcm1hcmtldKoBNxABMh4QASIai4xvZ_x85o79EySsX8JdYGBOsLiGElK0so4yExACIg9zdXBlY28gamFmaWxpeWE,y,PJdgYe0d9ks;mv:[[25.23724597731903,55.27948786858903],[25.236886022680974,55.279089931410965]]",
  },

  // {
  //   id: 2,
  //   image: apartment2,
  //   title: "Midtown Condo",
  //   discount: "10%",
  //   Installment: 7,
  // },

  // {
  //   id: 3,
  //   image: apartment3,
  //   title: "IL Bosco",
  //   discount: "5%",
  //   Installment: 9,
  // },

  // {
  //   id: 4,
  //   image: apartment4,
  //   title: "Vinci",
  //   discount: "5%",
  //   Installment: 9,
  // },

  // {
  //   id: 5,
  //   image: apartment5,
  //   title: "Serrano",
  //   discount: "15%",
  //   Installment: 6,
  // },

  // {
  //   id: 6,
  //   image: apartment6,
  //   title: "Atika",
  //   discount: "10%",
  //   Installment: 8,
  // },

  
];

// export const hotelApartmentsData = [
//   {
//     id: 1,
//     image: hotelApartment1,
//     title: "Central Iconic Tower",
//     discount: "10%",
//     Installment: 15,
//   },

//   {
//     id: 2,
//     image: hotelApartment2,
//     title: "6Ixty Iconic Tower",
//     discount: "10%",
//     Installment: 7,
//   },

//   {
//     id: 3,
//     image: hotelApartment3,
//     title: "East Tower",
//     discount: "10%",
//     Installment: 7,
//   },

//   {
//     id: 4,
//     image: hotelApartment4,
//     title: "Double Two Tower",
//     discount: "10%",
//     Installment: 6,
//   },

//   {
//     id: 5,
//     image: hotelApartment5,
//     title: "Rain Tower",
//     discount: "10%",
//     Installment: 5,
//   },
// ];

export const commercialData = [
  {
    id: 1,
    image: commercial1,
    title: "Al HANA CENTER",
    discount: "",
    Installment: 75,
    price:"65000",
    location:"https://www.google.com/search?q=alhana+center&sca_esv=624b65d66f479d2b&biw=1280&bih=559&tbm=lcl&ei=qv6uZ4ONBJeS9u8P8KKpiAg&oq=alhana+&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIgdhbGhhbmEgKgIIADIFEAAYgAQyBxAAGIAEGAoyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMgcQABiABBgKSIocUABY-wtwAHgAkAEBmAG4AqAB9QuqAQcwLjIuNC4xuAEDyAEA-AEBmAIGoALWCcICERAAGIAEGJECGLEDGIMBGIoFwgILEAAYgAQYkQIYigXCAgoQABiABBhDGIoFwgIQEAAYgAQYsQMYQxiDARiKBcICCxAAGIAEGLEDGIMBwgIIEAAYgAQYsQPCAggQABiABBjJA8ICCxAAGIAEGJIDGIoFmAMAkgcFMC4yLjSgB9Ym&sclient=gws-wiz-local#rlfi=hd:;si:3159076782158411867,l,Cg1hbGhhbmEgY2VudGVySOWDmb3egYCACFodEAAQARgBIg1hbGhhbmEgY2VudGVyKgYIAhAAEAGSAQ9idXNpbmVzc19jZW50ZXKaASRDaGREU1VoTk1HOW5TMFZKUTBGblNVUndNWEpsY0MxQlJSQUKqATYQATIfEAEiG92NOkFrqn0a848GcU1HestQ_RwmJ96dnxgIQjIREAIiDWFsaGFuYSBjZW50ZXL6AQQIABAj;mv:[[25.237214277319026,55.28026926853714],[25.23685432268097,55.27987133146286]]"
  },

  {
    id: 2,
    image: commercial2,
    title: "NOUF TOWER",
    discount: "",
    Installment: 3,
    price:"65000",
    location:"https://www.google.com/maps/place/Nouf+Tower+-+Umm+Hurair+Rd+-+Port+Saeed+-+Dubai/@25.2564891,55.3228773,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f5cd9fdf09eef:0x7c2b1430244aa912!8m2!3d25.2564843!4d55.3254522!16s%2Fg%2F1pzsr33b9?entry=ttu&g_ep=EgoyMDI1MDIxMS4wIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D",
  },

  // {
  //   id: 3,
  //   image: commercial3,
  //   title: "AL GOZE",
  //   discount: "",
  //   Installment: 11,
  //   price:"65000",
  //   location:"https://maps.app.goo.gl/3piLUgEtjvxjrLbu7"
  // },

  {
    id: 3,
    image: commercial3,
    title: "GROVE COURT",
    discount: "",
    Installment: 6,
    location:"https://maps.app.goo.gl/3piLUgEtjvxjrLbu7"

  },

  // {
  //   id: 5,
  //   image: commercial5,
  //   title: "SAFA CENTER",
  //   discount: "",
  //   Installment: 3,
  //   price:"65000",
  // },

  // {
  //   id: 5,
  //   image: commercial5,
  //   title: "HUDAIBA BUILDING",
  //   discount: "",
  //   Installment: 1,
  //   price:"65000",
  // },

  // {
  //   id: 6,
  //   image: commercial6,
  //   title: "Pint 9 Mall",
  //   discount: "10%",
  //   Installment: 8,
  // },
];

export const administrativeData = [
  {
    id: 1,
    image: administrative1,
    title: "Al HANA CENTER",
    discount: "",
    Installment: 75,
    price:"65000",
  },

  {
    id: 2,
    image: administrative2,
    title: "Nouf Tower",
    discount: "",
    Installment: 40,
    price:"65000",
  },

  // {
  //   id: 3,
  //   image: administrative3,
  //   title: "AL GOZE",
  //   discount: "",
  //   Installment: 35,
  //   location:"https://maps.app.goo.gl/3piLUgEtjvxjrLbu7"
  // },

  // {
  //   id: 4,
  //   image: administrative4,
  //   title: "Ronza Tower",
  //   discount: "15%",
  //   Installment: 7,
  // },

  // {
  //   id: 5,
  //   image: administrative5,
  //   title: "Onyx Tower",
  //   discount: "10%",
  //   Installment: 5,
  // },

  // {
  //   id: 6,
  //   image: administrative6,
  //   title: "Mizar Tower",
  //   discount: "10%",
  //   Installment: 5,
  // },
];

export const medicalData = [
  {
    id: 1,
    image: AHMMC,
    title: "Al HANA MODERN MEDICAL CENTER",
    discount: "10%",
    Installment: "",
    location: "https://maps.app.goo.gl/dxtoc8w8KvVF952x5",
  },

  {
    id: 2,
    image: emirates_hospital,
    title: "EMIRATES HOSPITAL",
    discount: "",
    Installment: "",
    location: "https://maps.app.goo.gl/wVP6VFToAqrWqSEQ8",
  },

  // {
  //   id: 3,
  //   image: medica3,
  //   title: "Senator",
  //   discount: "10%",
  //   Installment: 7,
  // },

  // {
  //   id: 4,
  //   image: medica4,
  //   title: "Ronza Tower",
  //   discount: "10%",
  //   Installment: 6,
  // },

  // {
  //   id: 5,
  //   image: medica5,
  //   title: "Senet",
  //   discount: "10%",
  //   Installment: 6,
  // },

  // {
  //   id: 6,
  //   image: medica6,
  //   title: "Evora Mall",
  //   discount: "16%",
  //   Installment: 9,
  // },
];

export const pharmaciesData = [
  {
    id: 1,
    image: pharmacy1,
    title: "ALHANA PHARMACY",
    discount: "",
    Installment: 1,
  },

  // {
  //   id: 2,
  //   image: pharmacy2,
  //   title: "Loft Mall",
  //   discount: "15%",
  //   Installment: 6,
  // },

  // {
  //   id: 3,
  //   image: pharmacy3,
  //   title: "UIN Tower",
  //   discount: "10%",
  //   Installment: 8,
  // },

  // {
  //   id: 4,
  //   image: pharmacy4,
  //   title: "Point 11",
  //   discount: "10%",
  //   Installment: 9,
  // },

  // {
  //   id: 5,
  //   image: pharmacy5,
  //   title: "Park Point Mall",
  //   discount: "10%",
  //   Installment: 6,
  // },

  // {
  //   id: 6,
  //   image: pharmacy6,
  //   title: "Pagoda Complex",
  //   discount: "15%",
  //   Installment: 5,
  // },
];

export const newupcomingdata = [
  {
    id: 1,
    image: archvilla,
    title: "THE ARCH VILLA",
    discount: "10%",
    Installment: 6,
  },

  // {
  //   id: 2,
  //   image: newCairo2,
  //   title: "",
  //   discount: "10%",
  //   Installment: 7,
  // },

  // {
  //   id: 3,
  //   image: newCairo3,
  //   title: "Axle",
  //   discount: "10%",
  //   Installment: 7,
  // },

  // {
  //   id: 4,
  //   image: newCairo4,
  //   title: "In Town Mall",
  //   discount: "15%",
  //   Installment: 8,
  // },

  // {
  //   id: 5,
  //   image: newCairo5,
  //   title: "Cinco",
  //   discount: "6%",
  //   Installment: 9,
  // },
];



// {
//   "id": 2,
//   "company": "Al Ghaith Properties",
//   "logo": "images/logowhtbg.png",
//   "isNew": true,
//   "featured": true,
//   "position": "MEP Engineer",
//   "role": "Fullstack",
//   "level": "Midweight",
//   "postedAt": "1d ago",
//   "contract": "Full Time",
//   "location": "Remote",
//   "languages": ["Python"],
//   "tools": ["React"]
// },
// {
//   "id": 3,
//   "company": "Al Ghaith Properties",
//   "logo": "images/logowhtbg.png",
//   "isNew": true,
//   "featured": false,
//   "position": "Junior Frontend Developer",
//   "role": "Frontend",
//   "level": "Junior",
//   "postedAt": "2d ago",
//   "contract": "Part Time",
//   "location": "USA Only",
//   "languages": ["JavaScript"],
//   "tools": ["React", "Sass"]
// },
// {
//   "id": 4,
//   "company": "Al Ghaith Properties",
//   "logo": "images/logowhtbg.png",
//   "isNew": false,
//   "featured": false,
//   "position": "Junior Frontend Developer",
//   "role": "Frontend",
//   "level": "Junior",
//   "postedAt": "5d ago",
//   "contract": "Contract",
//   "location": "USA Only",
//   "languages": ["CSS", "JavaScript"],
//   "tools": []
// }